<template>
  <div class="kanban-header">
    <div class="row items-center">
      <div class="text-heading-3 text-secondary-1">List of kanban boards</div>

      <q-space></q-space>

      <ExportBtn :loading="exportLoading" @click="downloadKanbanInformation" />
      <RBtn size="small" type="tertiary" class="q-ml-md" @click="newKanban">
        new kanban board
      </RBtn>
    </div>

    <BoardDialog ref="dialog" />
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
import { downloadFile } from '@lib/generic.utils'
// Components
import ExportBtn from '@/reusable/ExportBtn'
import BoardDialog from './BoardDialog'

export default {
  components: {
    ExportBtn,
    BoardDialog
  },

  data: () => ({
    exportLoading: false
  }),

  methods: {
    newKanban() {
      this.$refs.dialog.open()
    },

    downloadKanbanInformation() {
      this.exportLoading = true

      apiTo
        .GET_EXPORT_ENTITY_LINK('todo')
        .then(downloadFile)
        .finally(() => (this.exportLoading = false))
    }
  }
}
</script>
